import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyRoomcViewQuery,
  useRoomcCreateMutation,
  useRoomcUpdateMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const RoomCategory = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [name, setName] = useState("");
  const [service_type, setService_type] = useState("");
  const [payment_type, setPayment_type] = useState("");
  const [cancelation_policy, setCancelation_policy] = useState("");
  const [days, setDays] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [service_typeErr, setService_typeErr] = useState(false);
  const [payment_typeErr, setPayment_typeErr] = useState(false);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [addApi] = useRoomcCreateMutation();
  const [editApi] = useRoomcUpdateMutation();
  const [viewApi] = useLazyRoomcViewQuery();

  const submitHandler = () => {
    if (name?.length == 0) {
      setNameErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("name", name);

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        editApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: "Room Category Edited successfully",
                icon: "success",
              });
              navigate("/room-category-list");
            } else {
              alert(res?.message);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        addApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: "Room Category Added successfully",
                icon: "success",
              });
              navigate("/room-category-list");
            } else {
              alert(res?.message);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    viewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          let data = res?.room_category;
          if (data?.name) {
            setName(data?.name);
          }
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-service" : "add-service"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Room Category
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  placeholder="Enter Room Category"
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Room Category</p>
              )}
            </div>
          </Row>
          <Row>
            <div className="col-md-12 text-start mx-3 mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default RoomCategory;
